var WDN = WDN || {};

if (typeof WDN.TabTrigger === "undefined") {
  WDN.TabTrigger = (function () {
    class TabTrigger extends HTMLElement {
      constructor() {
        super();
      }

      storeNodes() {
        this.groupContainers = document.querySelectorAll("[data-tab-group='" + this.group + "']");
        this.content = document.querySelector("[data-tab-content='" + this.contentID + "']");
      }

      isActive(newState) {
        this.active = newState;

        // hide all containers
        this.groupContainers.forEach(function (container) {
          container.classList.add("hidden");
        });

        if (newState) {
          // set attribute
          this.setAttribute("data-active", "");

          // display container
          this.content.classList.remove("hidden");
          return;
        }

        this.removeAttribute("data-active");
      }

      setInitialState() {
        if (!this.active) return;
        this.isActive(this.active);
      }

      clearActiveTrigger() {
        var tagName = this.tagName.toLowerCase();
        var activeTrigger = document.querySelector(tagName + "[data-active][data-group='" + this.group + "']");
        if (!activeTrigger) return;
        activeTrigger.isActive(false);
      }

      onClick() {
        this.clearActiveTrigger();
        this.isActive(!this.active);

        if (typeof this.onClickCallback === "function") {
          this.onClickCallback();
        }
      }

      bind() {
        this.addEventListener("click", this.onClick.bind(this));
      }

      init() {
        // Required attributes
        this.group = this.getAttribute("data-group");
        this.contentID = this.getAttribute("data-content-id");

        // State
        this.active = this.getAttribute("data-active") === "";

        // init
        this.storeNodes();
        this.setInitialState();
        this.bind();
      }

      connectedCallback() {
        this.init();
      }
    }

    customElements.define("tab-trigger", TabTrigger);

    return TabTrigger;
  })();
}
